module.exports = __webpack_public_path__ + "static/media/musaned-logo.91129778.svg";